// extracted by mini-css-extract-plugin
export default {"body":"LayoutMini_body__6gvx0","container":"LayoutMini_container__YUa3F","miniContainer":"LayoutMini_miniContainer__zVnMc"};